import React, { useState, useContext } from 'react';
import styled from 'styled-components'
import { setPassword } from '../../api'
import { useSpring, animated } from 'react-spring'
import { AuthContext } from '../../auth-context'
import Input from '../../components/input.js'
import Button from '../../components/button.js'
import { ErrorMessage } from '../../components/error-message';

const Page = styled.div`
  background: #eff0f1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;

const Container = styled(animated.div)`
  display: flex;

  @media(max-width: 1020px) {
    margin: 0px 16px;
    width: 100%;
  }
`;

const Form = styled.div`
  background: #FFF;
  box-shadow: 0px 0px 15px 0px #cccfd1;
  border-radius: 8px;
  padding: 48px;
  width: 500px;

  @media(max-width: 1020px) {
    padding: 32px 24px;
    width: 100%;
  }
`;

const Title = styled.h2`
  color: #555;
  font-family: ${props => props.theme.font.primary};
  font-size: 1.25rem;
  font-weight: 500;
  margin: 0 0 32px 0;
`;

const Requirements = styled.ul`
  margin: 0 0 32px 0;
  padding-left: 24px;
  li {
    color: #777;
    font-size: .925rem;
    margin: 4px 0px;
  }
`;

const LoginButton = styled(Button)`
  width: 100%;
`;

const Login = (props) => {
  const { user, updateUser } = useContext(AuthContext);
  const formAnimation = useSpring({ opacity: 1, from: { opacity: 0 } })
  const [error, updateError] = useState(false)
  const [errorMessage, updateErrorMessage] = useState('')
  const [loading, updateLoading] = useState(false)
  const [password, updatePassword] = useState('')
  const [confirmPassword, updateConfirmPassword] = useState('')

  const validatePassword = () => {
    if(password !== confirmPassword) {
      updateErrorMessage('Passwords do not match.')
      updateError(true)
      return false;
    } else if(password.length < 8) {
      updateErrorMessage('Password must be at least 8 characters.')
      updateError(true)
      return false;
    } else if(!(/(?=.*[a-z]+)/.test(password))) {
      updateErrorMessage('Password must have at least one uppercase and one lowercase letter.')
      updateError(true)
      return false;
    } else if(!(/(?=.*[A-Z]+)/.test(password))) {
      updateErrorMessage('Password must have at least one uppercase and one lowercase letter.')
      updateError(true)
      return false;
    } else if(!(/(?=.*\d+)/.test(password))) {
      updateErrorMessage('Password must have at least one number.')
      updateError(true)
      return false;
    }

    return true;
  }

  const submitPassword = () => {
    if (validatePassword()) {
      updateLoading(true)
      setPassword(user.id, password).then((res) => {
        let newUser = Object.assign({}, user)
        newUser.password_set = 1        
        setTimeout(() => {
          updateUser(newUser)
          // App.js render handles redirect
        }, 1500);
      }).catch((err) => {
        // Server Error
        updateLoading(false)
      })
    }
  }

  const handleEnter = (e) => {
    if (e.key === 'Enter' && !loading) {
      submitPassword()
    }
  }
  
  return (
    <Page>
      <Container style={formAnimation}>
        <Form>
          <Title>Set Your Password</Title>
          <Requirements>
            <li>Must be at least 8 characters.</li>
            <li>Must have at least one uppercase and one lowercase letter.</li>
            <li>Must have at least one number.</li>
          </Requirements>
          <Input
            error={Boolean(error)}
            label="Password"
            type="password" 
            autoComplete="current-password" 
            value={password}
            onChange={updatePassword}
          />
          <Input
            error={Boolean(error)}
            label="Re-enter Password"
            type="password" 
            autoComplete="current-password" 
            value={confirmPassword}
            onChange={updateConfirmPassword}
            onKeyPress={handleEnter}
          />
          {error && 
            <ErrorMessage>
              {errorMessage}
            </ErrorMessage>
          }
          <LoginButton 
            label="Submit"
            isLoading={loading}
            disabled={loading}
            onClick={submitPassword}
          />
        </Form>
      </Container>
    </Page>
  )
}


export default Login
